var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.015,
    height: 18,
    viewBox: "0 0 18.015 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#22313f;stroke-miterlimit:10;stroke-width:1.5px;}.c{fill:#22313f;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-480 -4647.614)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.685,6h7.983a4.322,4.322,0,0,1,4.255,4.386h0a4.322,4.322,0,0,1-4.255,4.386H6.685A4.321,4.321,0,0,1,2.43,10.409h0A4.334,4.334,0,0,1,6.685,6Z",
    transform: "translate(478.342 4646.614)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.856,
    cy: 1.856,
    r: 1.856,
    transform: "translate(490.884 4655.167)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 1.5,
    height: 3.253,
    transform: "translate(484.75 4655.379)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnableIcon);
export default __webpack_public_path__ + "static/media/enable-icon.fe539dcaffb6ccddd0444cf54444cba4.svg";
export { ForwardRef as ReactComponent };